import { handleCall } from './handleResponse'

export const cauService = {
  getAll,
  create,
  update,
  remove,
  getById,
}

function getAll() {
  return handleCall(`/operators/v1/CauUsers`, {
    method: 'GET',
    body: null,
  })
}

function create(user) {
  return handleCall(`/operators/v1/CauUsers/Create`, {
    method: 'POST',
    body: JSON.stringify(user),
  })
}

function update(id, data) {
  return handleCall(`/operators/v1/CauUsers/${id}/Update`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

function remove(id) {
  return handleCall(`/operators/v1/CauUsers/${id}`, {
    method: 'DELETE',
    body: null,
  })
}

function getById(id) {
  return handleCall(`/operators/v1/CauUsers/${id}`, {
    method: 'GET',
    body: null,
  })
}
